// Generated by scripts/generate-vuetify-locales.mjs - DO NOT EDIT
import { en as en$vuetify, it as it$vuetify } from 'vuetify/locale';

export const vuetifyLocaleMap = {
  en: en$vuetify,
  it: it$vuetify
};
